export enum SearchDataSource {
  BROWSE_DATA_PI = 'browse',
  LISTINGS_API = 'listings',
  NAME = 'search_listing_data_source',
}

export enum GraphQLFetchWithAbort {
  DISABLED = 'disabled',
  // This feature flag is used to enable/disable the use of AbortController in the GraphQL fetch function.
  // This is useful for testing purposes, as it allows us to simulate a timeout error.
  ENABLED = 'enabled',
  NAME = 'graphql_fetch_with_abort',
}
